import React from 'react'
import UserAgreementDialog from './UserAgreementDialog'


const UserAgreementContainer = () => {
  return <UserAgreementDialog/>
}

export default UserAgreementContainer
